// Définition des catégories de documents pour le système CCIC
export const DOCUMENT_CATEGORIES_CONTENT = {
  "contrat_entente": {
    emoji: "📜",
    title: "1. Contrat et entente professionnelle",
    content: [
      "Contrat de services signé entre le CRIC et le client",
      "Entente de représentation professionnelle",
      "Conditions générales de service",
      "Mandat de représentation",
      "Accord de confidentialité",
      "Modifications ou avenants au contrat"
    ]
  },
  "justificatifs_correspondance": {
    emoji: "📧",
    title: "2. Documents justificatifs à l'appui de la demande - Correspondance et communications",
    content: [
      "Correspondance avec IRCC",
      "Lettres officielles et communications",
      "Courriels échangés avec le client",
      "Documents justificatifs de la demande",
      "Preuves à l'appui du dossier",
      "Communications avec tiers (employeurs, établissements)"
    ]
  },
  "biens_client": {
    emoji: "🏠",
    title: "3. Biens du client",
    content: [
      "Documents relatifs aux biens immobiliers",
      "Preuves de propriété",
      "Titres de propriété",
      "Évaluations de biens",
      "Documents d'actifs financiers",
      "Inventaire des biens"
    ]
  },
  "facturation_paiement": {
    emoji: "💳",
    title: "4. Documents de facturation et de paiement",
    content: [
      "Factures émises au client",
      "Reçus de paiement",
      "Relevés de compte",
      "Historique des paiements",
      "Notes de crédit",
      "Documents comptables"
    ]
  },
  "autorisation_representant": {
    emoji: "✍️",
    title: "5. Autorisation du représentant désigné",
    content: [
      "Formulaire IMM 5476 (si applicable)",
      "Autorisation de représentation signée",
      "Consentement du client",
      "Pouvoir de représentation",
      "Documents d'autorisation IRCC",
      "Procuration (si nécessaire)"
    ]
  },
  "documents_internes": {
    emoji: "📝",
    title: "6. Documents provisoires et notes internes",
    content: [
      "Notes de travail du CRIC",
      "Brouillons de documents",
      "Mémos internes",
      "Listes de vérification",
      "Documents provisoires",
      "Notes de suivi et observations"
    ]
  },
  "demandes_immigration": {
    emoji: "🛂",
    title: "7. Demandes d'immigration ou de citoyenneté",
    content: [
      "Formulaires de demande complétés",
      "Copies des demandes soumises",
      "Confirmations de soumission",
      "Numéros de demande et références",
      "Accusés de réception IRCC",
      "Documents de suivi de demande"
    ]
  },
  "registre_biens": {
    emoji: "📋",
    title: "8. Registre des biens du client",
    content: [
      "Registre détaillé des biens du client",
      "Liste des documents et biens en possession",
      "Date de réception des documents",
      "État et localisation des biens",
      "Journal des mouvements de documents",
      "Registre de restitution"
    ]
  }
};

// Anciennes catégories (conservées pour compatibilité)
export const OLD_DOCUMENT_CATEGORIES_CONTENT = {
  administratif: {
    emoji: "🧩",
    title: "1. Informations administratives du client",
    content: [
      "Formulaire interne d'ouverture de dossier",
      "Copie d'une pièce d'identité valide (passeport, carte nationale, etc.)",
      "Coordonnées complètes (adresse, téléphone, courriel)",
      "Numéro de client interne et code de dossier",
      "Date d'ouverture et de clôture prévue"
    ]
  },
  historique: {
    emoji: "🧠",
    title: "2. Historique du client et objet de la demande",
    content: [
      "Type de programme d'immigration visé (ex. : permis de travail, résidence permanente, études, visite, asile, etc.)",
      "Antécédents d'immigration au Canada (visas précédents, refus, expulsions, etc.)",
      "Objectif du projet d'immigration (motif du séjour, plan de carrière, projet d'établissement)"
    ]
  },
  identite: {
    emoji: "📋",
    title: "3. Documents d'identité et d'état civil",
    content: [
      "Passeport (page d'identité et tampons d'entrée)",
      "Acte de naissance",
      "Acte de mariage ou divorce (le cas échéant)",
      "Acte de naissance des enfants (le cas échéant)",
      "Preuve de garde légale (le cas échéant)"
    ]
  },
  formation: {
    emoji: "🎓",
    title: "4. Documents relatifs à la formation et à l'expérience",
    content: [
      "Diplômes, relevés de notes, attestations d'études",
      "Évaluations comparatives (ÉDE, WES, etc. si requis)",
      "Curriculum vitae à jour",
      "Lettres d'expérience professionnelle (avec coordonnées d'employeurs)",
      "Contrats de travail et fiches de paie"
    ]
  },
  financier: {
    emoji: "💼",
    title: "5. Preuves financières",
    content: [
      "Relevés bancaires récents",
      "Preuves de revenus (fiches de paie, attestations d'emploi)",
      "Déclarations fiscales",
      "Lettres de soutien financier (garant, commanditaire, etc.)",
      "Attestations de propriété ou d'actifs (immobiliers, véhicules, etc.)"
    ]
  },
  programme: {
    emoji: "🏛️",
    title: "6. Documents relatifs au programme d'immigration",
    content: [
      "Offre d'emploi ou LMIA (le cas échéant)",
      "CAQ, lettre d'admission, permis d'études (le cas échéant)",
      "Lettres d'invitation, preuves de relation (pour parrainage ou visite)",
      "Preuves d'établissement ou de résidence au Canada (pour les travailleurs)"
    ]
  },
  formulaires: {
    emoji: "📝",
    title: "7. Formulaires et déclarations officielles",
    content: [
      "Formulaires IRCC/IRPA remplis et signés",
      "Déclaration d'intérêt ou profil Entrée Express (si applicable)",
      "Représentation IMM 5476 (représentant autorisé)",
      "Consentement pour divulgation d'informations",
      "Questionnaire personnalisé du cabinet"
    ]
  },
  communication: {
    emoji: "📑",
    title: "8. Documents de communication et correspondance",
    content: [
      "Notes de consultation initiale",
      "Courriels et lettres échangées avec le client",
      "Copies des soumissions IRCC",
      "Preuves de paiement (honoraires, frais IRCC, biométrie, etc.)",
      "Captures d'écran du portail IRCC ou MIFI (si applicable)"
    ]
  },
  soumission: {
    emoji: "✍️",
    title: "9. Lettre de soumission et argumentaire juridique",
    content: [
      "Lettre de présentation rédigée par le consultant",
      "Références aux articles de la LIPR, du RIPR ou guides IRCC",
      "Résumé de la situation du client et justification de l'admissibilité",
      "Liste des pièces jointes (numérotées : P1, P2, P3, etc.)"
    ]
  },
  suivi: {
    emoji: "📬",
    title: "10. Suivi du dossier et mise à jour",
    content: [
      "Registre des statuts de la demande (soumise, en traitement, décision)",
      "Notes internes sur communications avec IRCC",
      "Suivi post-soumission (biométrie, VM, correspondances)",
      "Résultat final (approbation, refus, décision, lettre finale)"
    ]
  },
  archivage: {
    emoji: "📁",
    title: "11. Archivage et clôture du dossier",
    content: [
      "Résumé final du dossier",
      "Copie du visa, permis, ou CRP reçu",
      "Lettre de clôture envoyée au client",
      "Archivage numérique selon les exigences du CICC (6 ans minimum)"
    ]
  }
};
